import styled from 'styled-components';
import { red } from 'constants/colors';
import { BUBBLE_SIZE, SATELLITES_SIZE, INLINE_ELEMENTS_SIZE } from './constants';

export const ThemeTablesGrid = styled.div`
  display: grid;
  grid-template-rows: calc(100% - 6rem) 6rem;
  height: ${props => props.height}px;

  .theme_tables_overflow {
    overflow: hidden;
    position: relative;
    cursor: pointer;
    * {
      cursor: pointer;
    }
  }

  .options_wrapper {
    text-align: center;
    > div {
      display: inline-block;
      vertical-align: middle;
    }
    .slider_wrapper {
      padding: 0 2rem;
      width: calc(100% - 12rem);
      max-width: 50rem;
    }

    .btn-fullscreen {
      width: 10rem;
      background-color: rgba(255, 255, 255, 0.5);
      border-radius: 2rem;
      color: #fff;
      padding: 0.5rem;
      font-size: 1.2rem;
      i {
        margin-left: 0.5rem;
      }
    }
  }

`;

export const ThemeTablesWrapper = styled.div`
  position: relative;
  width: ${props => props.size.width}px;
  height: ${props => props.size.height}px;
  cursor: move;
`;

export const Bubble = styled.div`
  border-radius: 50%;
  background-color: #ccc;
  position: absolute;
  cursor: pointer;
  background-image: ${props => (props.image ? `url(${props.image})` : 'none')};
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  transition: opacity ease 0.3s;

  .opacity {
    display: ${props => (props.image ? 'block' : 'none')};
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    pointer-events: none;
    border-radius: 50%;
  }

  &.not_pass_filter {
    opacity: 0.4;
  }

  &.selected {
    &.lg {
      box-shadow: 0 0 0 1.7rem rgb(255 255 255 / 40%)
    }
    &.md {
      box-shadow: 0 0 0 1.3rem rgb(255 255 255 / 40%)
    }
    &.xs {
      box-shadow: 0 0 0 1rem rgb(255 255 255 / 40%)
    }

  }

  img {
    pointer-events: none;
  }

  .bubble_content {
    position: relative;
    width: 100%;
    text-align: center;
    z-index: 2;
    overflow: hidden;
    border-radius: 50%;
    overflow: hidden;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > div {
      width: 85%;
      margin: 0 auto;
    }
  }

  .name {
    padding: 0.1rem 0.6rem;
    font-weight: 600;
    overflow: hidden;
    color: #fff;
    text-align: center;
    width: 100% !important;
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;

    .is_new {
      color: ${red};
      display: inline-block;
      margin: 0 0.5rem;
      font-style: italic;
    }
  }

  .tag {
    background-color: #fff;
    border-radius: 10px;
    color: #444;
    padding: 0.3rem;
    font-size: 0.9rem;
    border: 0.1rem solid #ddd;
    display: inline-block;
    margin: 0.2rem 0.2rem 0 0;
  }

  .inline_elements {
    white-space: nowrap;
    margin-bottom: 0.5rem;

    .avatar_bubble {
      margin-right: -1rem;
      position: relative;
    }

    .more_indicator {
      border-radius: 50%;
      background-color: #fff;
      text-align: center;
      font-weight: 600;
      letter-spacing: 0.1rem;
      display: inline-block;
      position: relative;
      z-index: 20;
      vertical-align: middle;
    }
  }

  &.xs {
    width: ${BUBBLE_SIZE.xs}px;
    height: ${BUBBLE_SIZE.xs}px;
    border: ${props => (props.highlighted ? `0.4rem solid ${props.color}` : '0rem')};

    .inline_elements {
      .more_indicator {
        width: ${INLINE_ELEMENTS_SIZE.xs / 10}rem;
        height: ${INLINE_ELEMENTS_SIZE.xs / 10}rem;
        line-height: ${INLINE_ELEMENTS_SIZE.xs / 10}rem;
        font-size: 0.5rem;
      }
    }

    .name {
      font-size: 0.6rem;
      line-height: 0.8rem;
      max-height: 2.4rem;
    }

    .tag {
      font-size: 0.5rem;
    }
  }

  &.md {
    width: ${BUBBLE_SIZE.md}px;
    height: ${BUBBLE_SIZE.md}px;
    border: ${props => (props.highlighted ? `0.6rem solid ${props.color}` : '0rem')};

    .inline_elements {
      .more_indicator {
        width: ${INLINE_ELEMENTS_SIZE.md / 10}rem;
        height: ${INLINE_ELEMENTS_SIZE.md / 10}rem;
        line-height: ${INLINE_ELEMENTS_SIZE.md / 10}rem;
        font-size: 0.7rem;
      }
    }

    .name {
      font-size: 0.7rem;
      line-height: 0.9rem;
      max-height: 2.9rem;
    }

    .tag {
      font-size: 0.7rem;
    }
  }

  &.lg {
    width: ${BUBBLE_SIZE.lg}px;
    height: ${BUBBLE_SIZE.lg}px;
    border: ${props => (props.highlighted ? `0.8rem solid ${props.color}` : '0rem')};

    .inline_elements {
      .more_indicator {
        width: ${INLINE_ELEMENTS_SIZE.lg / 10}rem;
        height: ${INLINE_ELEMENTS_SIZE.lg / 10}rem;
        line-height: ${INLINE_ELEMENTS_SIZE.lg / 10}rem;
        font-size: 0.8rem;
      }
    }

    .name {
      font-size: 0.9rem;
      line-height: 1.2rem;
      max-height: 3.6rem;
    }

    .tag {
      font-size: 0.8rem;
    }
  }
`;

export const Satellite = styled.div`
  position: absolute;
  z-index:100;

  &.sat_0 {
    left: 0;
    top: 50%;
    transform: translate(-80%, -50%);
  }

  &.sat_1 {
    left: 15%;
    top: 10%;
    transform: translate(-50%, -50%);
  }

  &.sat_2 {
    left: 15%;
    top: 85%;
    transform: translate(-50%, -50%);
  }

  &.sat_3 {
    left: 50%;
    top: -1%;
    transform: translate(-50%, -50%);
  }

  &.sat_4 {
    left: 50%;
    top: 100%;
    transform: translate(-50%, -50%);
  }

  &.sat_5 {
    left: 65%;
    top: 10%;
    transform: translate(50%, -50%);
  }

  &.more_indicator {
    background-color: #000;
    color: #fff;
    width: ${SATELLITES_SIZE.xs / 10}rem;
    height: ${SATELLITES_SIZE.xs / 10}rem;
    line-height: ${SATELLITES_SIZE.xs / 10}rem;
    border-radius: 50%;
    text-align: center;
    font-weight: 600;
    letter-spacing: 0.1rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ThemeTablesBubbles/components/styles.js